// extracted by mini-css-extract-plugin
export default {"alert":"alert-FdSc"};